import React from 'react'

const about = {
    id: 'about',
    title: 'About Us',
    coverImage: 'https://plivesey.github.io/world-of-wander-images/posts/about/aboutPhoto.jpg',
    content: [
        {
            text: (
                <div>Hi! We're Peter and Alice, a couple who left San Francisco in 2018 to travel the world. We created this site to share stories and pictures of our adventures with friends and family. If you landed here and you don't already know us, welcome.</div>
            )
        },
        {
            text: (
                <div>Before we quit our jobs and gave up our apartment, we loved California. It has so many opportunities to get outside and hike, swim, kayak, ski, and more. But with jobs in the busy tech industry, we spent too many weekends "recuperating" with Netflix and too many hours hunched over desks. We consistently spent all of our limited American vacation time traveling abroad and were able to make it to places including Japan, Norway, Montenegro, Iceland, and Nicaragua in between trips to see Peter's family in the U.K. While we were immensely privileged to be able to travel that much, we always wanted to see more and experience the world differently than we could on these short trips.</div>
            )
        },
        {
            text: (
                <div>So we put everything in storage (a.k.a. Kexin's house…. thanks, Kexin!!) and took a leap. We are traveling more slowly, taking on more physical challenges, and spending time on personal projects. We hope you enjoy following along.</div>
            )
        },
        {
            text: (
                <br />
            )
        },
        {
            text: (
                <div><i>All country icons designed by Linseed Studio from the Noun Project.</i></div>
            )
        },
    ]
}

export default about


// WEBPACK FOOTER //
// ./src/Posts/Content/About.js